import { CanActivate, Router } from "@angular/router";
import { Injectable } from "@angular/core";
import {SessionStorageService} from "../../services/session-storage.service";
import {PremiumServicesService} from "../../services/premium-services.service";
import {Observable, tap} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class PremiumActiveTimeGuard implements CanActivate {

  constructor(
    private router: Router,
    private sessionStorageService: SessionStorageService,
    private premiumServices: PremiumServicesService
  ) {}

  canActivate(): Observable<boolean> {
    this.premiumServices.refreshPaidServiceState();
    return this.premiumServices.isPaidServiceActive$.pipe(
      map(val => val || this.sessionStorageService.isPremiumGraceSession()),
      tap(isAllowed => {
        if (!isAllowed) this.router.navigateByUrl("/");
      })
    );
  }
}
